import { render, staticRenderFns } from "./ProfilePatten.vue?vue&type=template&id=8701f72e&"
import script from "./ProfilePatten.vue?vue&type=script&lang=js&"
export * from "./ProfilePatten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports